export const ACCESS_TOKEN = 'token_access_v6'
export const REFRESH_TOKEN = 'token_refresh_v6'
export const PROJECT_ID = 'project_id'
export const BILLING_ACCOUNT_ID = 'billing_account_id'

export const ACCESS_TOKEN_APP_V1 = 'token_access_v6_app_v1'
export const REFRESH_TOKEN_APP_V1 = 'token_refresh_v6_app_v1'
